import { ArrowLeftOutlined } from '@ant-design/icons';
import { Typography, Button } from 'antd';
import React from 'react'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import "./pageStyle.css"
// @ts-ignore
import { markettingWebUrl } from '../../../environment/environment';

interface HeaderProps {
    pagTitle: string;
    button?: boolean;
    exportButton?: any;
    handleExport?: any;
    buttonLink?: string;
    buttonLabel?: string;
    buttonClick?: any;
    isSuperAdmin?: boolean;
    activeTab: 'home' | 'openApi' | 'zapier' | 'contact'
    setActiveTab: (tab: 'home' | 'openApi' | 'zapier' | 'contact') => void

}

const PageTitle: React.FC<HeaderProps> = ({ pagTitle, button, exportButton, handleExport, buttonLink, buttonLabel, buttonClick, isSuperAdmin = false, setActiveTab   // 👈 ADD THIS
}) => {
    const navigate = useNavigate();

    const { Title, Paragraph, Text } = Typography;
    const userData = useSelector((state: any) => state?.Auth?.user);

    const handleBackClick = () => {
        navigate(`${markettingWebUrl}`); // Navigate back
    };
    let buttonLabelWithClicks = ['Add Ticket', 'Refer ReferUs', `Add Category`]
    const handleButtonClick = () => {
        if (buttonLabelWithClicks?.includes(buttonLabel)) {
            buttonClick()
        }
        navigate(buttonLink)
    }

    return (
        <div className='py-10'>
            <div className="d-flex justify-content-between">
                <div className="bodycardheading">
                    <div className="mobileView buttonsvgs" onClick={() => navigate(-1)}>
                        {' '}
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="25"
                            viewBox="0 0 24 25"
                            fill="none"
                        >
                            <rect
                                x="0.4"
                                y="1.18168"
                                width="23.2"
                                height="23.2"
                                rx="11.6"
                                stroke="#F47523"
                                stroke-width="0.8"
                            />
                            <path
                                d="M14 8.78168L10 12.7817L14 16.7817"
                                stroke="#F47523"
                                stroke-width="1.25"
                                stroke-linecap="round"
                            />
                        </svg>
                    </div>
                    {pagTitle}
                </div>
                <div className='d-flex' style={{ gap: '3px' }}>
                    {(button && isSuperAdmin) && <Button size='small' style={{ height: '39px', fontSize: '12px' }} type='primary' onClick={() => handleButtonClick()} className='btn btn-primary'>{buttonLabel}</Button>}
                    {/* {(button && userRoleId !==1) && <Button size='small' style={{height: '39px', fontSize: '12px'}} type='primary' onClick={() => handleButtonClick()} className='btn btn-primary'>{buttonLabel}</Button>} */}

                    {(exportButton) &&
                        <Button size='small' style={{ height: '39px', fontSize: '12px' }} type='primary' onClick={() => handleExport()} className='btn btn-primary'>Export</Button>}
                </div>
            </div>

            <div className="doc-page doc-intro">

                <div className="overviewNotice" onClick={() => setActiveTab?.('contact')}
                >
                    <strong>Need help with integration?</strong>
                    <p>
                        If you’re unable to integrate ReferUs, please contact us at{' '}
                        <a href="mailto:info@referusnetwork.com">info@referusnetwork.com</a>.
                    </p>
                </div>

                <h2 className="doc-title">
                    <Title level={2}>                <Button type="link" onClick={handleBackClick} icon={<ArrowLeftOutlined style={{ color: "#000", fontSize: "24px", display: "flex", alignItems: 'center' }} />} /> &nbsp;ReferUs Integrations</Title>
                </h2>

                <h4>Connect ReferUs to the Systems You Already Use</h4>

                <p>
                    ReferUs can now link with other software your business runs, so referral information can move between systems instead of being entered manually in multiple places.
                </p>

                <p>There are two ways to do this.</p>

                <h3>
                    Option 1:{' '}&nbsp;
                    <span
                        className="doc-link"
                        onClick={() => setActiveTab?.('zapier')}
                    >
                        Zapier Integration
                    </span>&nbsp;
                    (Do it yourself with your team or<span className='doc-link' onClick={() => setActiveTab?.('contact')}>&nbsp;contact us</span>)
                </h3>

                <p>
                    Zapier is a tool that lets different business apps talk to each other without coding.
                </p>

                <p>
                    Using this, ReferUs can automatically pass information to or receive information from other systems.
                </p>

                <strong>Common real-world examples include:</strong>

                <ul>
                    <li>A form is completed on your website → a referral is created in ReferUs</li>
                    <li>A sale is marked complete in your CRM → the referral status is updated</li>
                    <li>A new customer is added to your system → they are invited to become a referrer</li>
                    <li>A referral is submitted → your internal team receives a notification</li>
                </ul>

                <p>
                    This approach primarily reduces manual handling, duplicated effort, and missed operational steps.
                </p>

                <h3>Option 2:&nbsp;    <span
                    className="doc-link"
                    onClick={() => setActiveTab?.('openApi')}
                >
                    &nbsp;Open API
                </span>&nbsp;
                    (Do it yourself with your team or <span className='doc-link' onClick={() => setActiveTab?.('contact')}>&nbsp;contact us</span>)</h3>

                <p>
                    If your business has technical support, the ReferUs API allows direct integration into your systems.
                </p>

                <p>
                    This means your internal software, CRM, website or apps can send and receive referral data directly with ReferUs
                </p>

                <strong>Typical use cases include:</strong>

                <ul>
                    <li>Creating referrals from your own forms or applications</li>
                    <li>Automatically updating referral stages</li>
                    <li>Triggering internal workflows when referral activity occurs</li>
                    <li>Sending referral data to reporting or analytics dashboards</li>
                    <li>Linking referrals to existing customer records inside your CRM</li>
                </ul>

                <p>
                    With this approach, ReferUs becomes part of your existing workflow rather than a separate process.
                </p>

                <h3>Operational Impact</h3>

                <ul>
                    <li>Referrals don’t rely on someone remembering to copy information.</li>
                    <li>Data doesn’t have to be entered more than once.</li>
                    <li>Status updates can happen automatically</li>
                    <li>Notifications and follow-ups can be triggered by system events.</li>
                </ul>

                <p>
                    The goal is to reduce gaps and manual steps in referral handling while improving consistency.
                </p>

                <h3>Technical Overview (For IT Teams)</h3>

                <ul>
                    <li>Secure authentication</li>
                    <li>Encrypted data transfer</li>
                    <li>Permission-based access controls</li>
                    <li>Activity logging</li>
                    <li>Webhooks for real-time updates</li>
                    <li>A sandbox environment for testing and validation</li>
                </ul>

                <h3>Summary</h3>

                <ul>
                    <li>Zapier is for simple, no-code automation.</li>
                    <li>Open API is designed for deeper integrations managed by technical teams</li>
                </ul>

                <p>
                    Both approaches allow referral activity to integrate seamlessly with your existing business systems instead of operating in isolation.
                </p>

            </div>
        </div>
    )
}

export default PageTitle